var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9995 16.0005L11.9995 12.0005M11.9995 12.0005L7.99947 16.0005M11.9995 12.0005V21.0005M20.3895 18.3905C21.3648 17.8587 22.1353 17.0174 22.5793 15.9991C23.0234 14.9808 23.1157 13.8437 22.8417 12.7672C22.5677 11.6906 21.943 10.736 21.0661 10.0539C20.1893 9.37185 19.1103 9.00121 17.9995 9.00047H16.7395C16.4368 7.82971 15.8726 6.74281 15.0894 5.82147C14.3062 4.90012 13.3243 4.16832 12.2176 3.68108C11.1108 3.19384 9.90802 2.96383 8.69959 3.00835C7.49116 3.05288 6.30854 3.37077 5.24065 3.93814C4.17276 4.5055 3.24738 5.30758 2.53409 6.28405C1.8208 7.26053 1.33816 8.38601 1.12245 9.57587C0.906742 10.7657 0.963577 11.989 1.28869 13.1537C1.61379 14.3185 2.19871 15.3943 2.99947 16.3005",
    stroke: "#353B60",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadCloud);
export default __webpack_public_path__ + "static/media/upload-cloud.f08b9c0d.svg";
export { ForwardRef as ReactComponent };